import { GetScreenshotLabelsRequest, GetScreenshotLabelsResponse } from '@eigtech/meetings-types'
import { contextualGet, queryOptions, useQuery, useQueryClient } from '@eigtech/ui-shared-api'
import { meetingsBasePath, meetingsQueryKeys } from './constants'

const getScreenshotLabels = ({ meetingId, entityId, startTime }: GetScreenshotLabelsRequest) =>
  contextualGet<GetScreenshotLabelsResponse>(
    `${meetingsBasePath}/meeting/screenshotlabels/${entityId}/${startTime}/${meetingId}`
  )

export const getScreenshotLabelsQueryOptions = (request: GetScreenshotLabelsRequest) =>
  queryOptions({
    queryKey: meetingsQueryKeys.screenshotLabels(request),
    queryFn: () => getScreenshotLabels(request),
    enabled: !!(request.entityId && request.meetingId && request.startTime),
  })

export const useGetScreenshotLabels = (request: GetScreenshotLabelsRequest) =>
  useQuery(getScreenshotLabelsQueryOptions(request))

export function useInvalidateScreenshotLabels() {
  const queryClient = useQueryClient()

  return function invalidateScreenshotLabels(request: GetScreenshotLabelsRequest) {
    queryClient.invalidateQueries({ queryKey: meetingsQueryKeys.screenshotLabels(request) })
  }
}
